import { render, staticRenderFns } from "./PlatformSelector.vue?vue&type=template&id=5311fe6f&scoped=true&"
import script from "./PlatformSelector.vue?vue&type=script&lang=js&"
export * from "./PlatformSelector.vue?vue&type=script&lang=js&"
import style0 from "./PlatformSelector.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PlatformSelector.vue?vue&type=style&index=1&id=5311fe6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5311fe6f",
  null
  
)

export default component.exports